var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open && _vm.node
    ? _c(
        "div",
        {
          staticClass: "wkb-node-action-menu",
          style: { left: `${_vm.clampedLeft}px`, top: `${_vm.clampedTop}px` },
          attrs: {
            role: "menu",
            "aria-label": `Actions for ${_vm.node.label || _vm.node.id}`,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "wkb-node-action-btn",
              attrs: { type: "button", role: "menuitem" },
              on: {
                click: function ($event) {
                  return _vm.emitAndClose("inspect")
                },
              },
            },
            [_vm._v(" Inspect node ")]
          ),
          _c(
            "button",
            {
              staticClass: "wkb-node-action-btn",
              class: { "wkb-node-action-btn-blocked": !_vm.canRemove },
              attrs: {
                type: "button",
                role: "menuitem",
                disabled: !_vm.canRemove,
                title: _vm.removeNodeTitle,
              },
              on: { click: _vm.onRemoveNode },
            },
            [_vm._v(" Remove node ")]
          ),
          _c(
            "button",
            {
              staticClass: "wkb-node-action-btn",
              attrs: { type: "button", role: "menuitem" },
              on: {
                click: function ($event) {
                  return _vm.emitAndClose("expand")
                },
              },
            },
            [_vm._v(" Expand graph from node ")]
          ),
          _c(
            "button",
            {
              staticClass: "wkb-node-action-btn",
              attrs: { type: "button", role: "menuitem" },
              on: {
                click: function ($event) {
                  return _vm.emitAndClose("select-connected")
                },
              },
            },
            [_vm._v(" Select connected nodes ")]
          ),
          _c(
            "button",
            {
              staticClass: "wkb-node-action-btn",
              attrs: { type: "button", role: "menuitem" },
              on: {
                click: function ($event) {
                  return _vm.emitAndClose("toggle-key-node")
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isKeyNode
                      ? "Remove from selected nodes"
                      : "Mark as selected node"
                  ) +
                  " "
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }